module.exports = __webpack_public_path__ + "img/f1c66db.jpg";